export const playerOffset = {
    "type1-center" : {x : 6, z : -18},
    "type1-corner" : {x : 3, z : -18},
    "type2-center" : {x: 10, z : -25},
    "type2-corner" : {x : 10, z : -25},
    "type3-center" : {x: -9, z : -24},
    "type3-corner" : {x: -14, z : -25},
}
{/* <Ground size={floorSize} />
                            <WalkableArea size={floorSize} />
                            <Ceiling size={floorSize} />
                            <LeftWall size={floorSize} position={[0, 0, -125]} />
                            <FrontWall size={floorSize} />
                            <RightWalln size={floorSize} position={[0, 0, 123]} />
                            <Carpet size={floorSize} />
                            <SideBoundary size={floorSize} />
                            <Door size={floorSize} />
                            <Sign size={floorSize} />
                            <TeleportMarker/>
                            <FPSNew/>
                            <Collider data={positionData} />
                            <Collision data={positionData} instanceSize={stallData.length} />
                            <TotamPhysics size={floorSize} />
                            <Type1Center positionData={positionData["type1-center"].pos} color={positionData["type1-center"].color} />
                            <Type1Corner positionData={positionData["type1-corner"].pos} color={positionData["type1-corner"].color} />
                            <Type2Center positionData={positionData["type2-center"].pos} color={positionData["type2-center"].color} />
                            <Type2Corner positionData={positionData["type2-corner"].pos} color={positionData["type2-corner"].color} />
                            <Type3Center positionData={positionData["type3-center"].pos} color={positionData["type3-center"].color} />
                            <Type3Corner positionData={positionData["type3-corner"].pos} color={positionData["type3-corner"].color} />
                            <VCTable data={positionData} />
                            <StallsLight data={positionData} />
                            <Broucher data={positionData} instanceSize={stallData.length} />
                            <Reception2 data={positionData} instanceSize={stallData.length} />
                            <Display data={positionData} />
                            <Banners data={positionData} />
                            <Hotspot data={positionData} hotspotData={hotspotData} />
                            <VCStand data={positionData} />
                            <KTv data={positionData} />
                            <Standee data={positionData} />
                            <ReceptionTable data={positionData} instanceSize={stallData.length} />
                            <Totam size={floorSize} sponsorsData={sponsorsData} />
                            <SponsorBanner size={floorSize} sponsorsData={sponsorsData} />
                            <HangingFlexes stallData={p */}